<template>
<main class="SectionArtistFull-MAIN">

    <section v-if="viewModeFromUrl == 'cover'" class="SectionArtistFull-cover" @click="changeViewMode('info')" @touchend="changeViewMode('info')">
        <p>
            {{ artistData?.apellido }}, {{ artistData?.nombre }}
            <br/>
            <span>[ID: AP 00{{ artistData?.id }}]</span>
        </p>
    </section>

    <section v-if="viewModeFromUrl == 'info'" class="SectionArtistFull-info">
        <hr/>
        <h2>{{ artistData?.apellido }}, {{ artistData?.nombre }}</h2>
        <p><span>[ID: AP 00{{ artistData?.id }}]</span></p>
        <div class="ArtistFull-grid">
            <p>Edad:</p>
            <p><span>{{ artistData?.birthday || 0 }}</span></p>
            <p>Origen:</p>
            <p><span>{{ artistData?.birthplace || 'origen' }}</span></p>
            <p>Disciplinas:</p>
            <p><span>{{ artistData?.disciplines?.join(', ') || 'disciplinas' }}</span></p>
            <p>Formación:</p>
            <p><span>{{ artistData?.studies || 'formación' }}</span></p>
        </div>
        <div class="ArtistFull-cat">
            <p @click="changeViewMode('detail'), detailType = 'bio'" v-if="artistData?.bio">Bio &gt;</p>
            <p @click="changeViewMode('detail'), detailType = 'trayectoria'">Trayectoria &gt;</p>
            <!--<p @click="changeViewMode('detail'), detailType = 'proyectos'">Proyectos &gt;</p>-->
            <p @click="changeViewMode('artworks')">[Ver obra]</p>
        </div>
    </section>
    
    <section v-if="viewModeFromUrl == 'detail'" class="SectionArtistFull-detail">
        <hr/>
        <h2>{{ detailType }}</h2>
        <div class="hide-scrollbar">
            <div v-if="detailType == 'bio'" class="bio-block">
                {{ artistData?.bio }}
            </div>
            <div v-if="detailType == 'trayectoria'">
                <div v-for="(item, index) in Object.keys(careerData)" :key="index">
                    <h3>{{ item }}</h3>
                    <div v-for="(subItem, subIndex) in careerData[item]" :key="subIndex" class="trayectoria-block">
                        <span>{{ subItem.date || '0000' }}</span>
                        <span>{{ subItem.institution }}</span>
                    </div>
                </div>
            </div>
            <div v-if="detailType == 'proyectos'">(Aquí deben ir los proyectos, pero aún no hay tabla en base de datos)</div>
        </div>
    </section>

    <section v-if="viewModeFromUrl == 'artworks'" class="SectionArtistFull-artworks">
        <div class="tiles-container hide-scrollbar">
            <RandomTiles :artworks="artworksData"/>
        </div>
    </section>

</main>
</template>

<script>
import RandomTiles from '@/components/RandomTiles.vue';

export default {
    name: 'SectionArtistFull',
    components: {
        RandomTiles,
    },
    props: {
        id: { type: [String, Number], required: true }
    },
    data(){
        return{
            detailType: '',
            artistData: {},
            artworksData: [],
            careerData: {},
        }
    },
    methods: {
        changeViewMode(viewMode){
            this.$router.push({ name: 'artistfull', params: { id: String(this.id) }, query: { view: viewMode } });
            this.viewMode = viewMode;
        },
    },
    async mounted(){
        const response = await fetch(`${this.$ENDPOINT}/api/artist_data.php?artist_id=${this.id}`);
        const result = await response.json();
        this.artistData = result.artist;
        this.artworksData = result.obras;
        for(let c of result.career){
            if(!this.careerData[c.type])
                this.careerData[c.type] = [];
            this.careerData[c.type].push(c);
        }
    },

    computed: {
        viewModeFromUrl() {
            const allowed = new Set(['cover', 'info', 'detail', 'artworks'])
            const v = String(this.$route.query.view || 'cover').toLowerCase()
            return allowed.has(v) ? v : 'cover'
        }
    }
}
</script>

<style scoped lang="stylus">
.SectionArtistFull-MAIN
    height: 100dvh
    max-height: 100dvh
    overflow: hidden
    position: relative
    color: white

    >section

        >*
            margin-left: auto
            margin-right: auto
            max-width: calc(100% - 8vw)

        >hr
            border-bottom: 1px solid white

            &:first-child
                margin-top: 6vw

/* cover */
.SectionArtistFull-cover
    height: 100%

    >p
        position: fixed
        margin: auto
        left: 0
        right: 0
        bottom: calc(6vw + 47px)
        width: fit-content
        text-align: center
        font-family:"DM Mono", monospace
        font-size: 4.5vw

        span
            font-weight: 100
            font-size: 3.3vw

/* info */
.SectionArtistFull-info
    height: 100%

    >h2
    >p
        font-family:"DM Mono", monospace

    >h2
        margin-bottom: 0
        font-weight: 100
        text-transform: uppercase

    >p
        margin-top: 0

        span
            font-weight: 100
            font-size: 3vw
    
    .ArtistFull-grid
        display: grid
        grid-template-columns: auto auto
        grid-gap: 3vh 0
        margin-top: 6vh
        text-transform: uppercase
        font-family:"DM Mono", monospace

        p
            margin: 0

        span
            font-weight: 100

    .ArtistFull-cat
        position: absolute
        bottom: calc(6vw)
        left: 0
        right: 0
        margin: 0 auto
        border-bottom: 1px solid white

        >p
            font-family:"DM Mono", monospace
            font-size: 5vw
            border-top: 1px solid white
            margin: 1ch 0
            padding-top: 1ch
            text-transform: uppercase
            cursor: pointer

/* detail */
.SectionArtistFull-detail
    height: 100%

    >h2
    h3
    >div
        font-family:"DM Mono", monospace

    >h2
    h3
        margin-bottom: 0
        font-weight: 100
        text-transform: uppercase

    h3
        margin-top: 0
        border-top: 1px solid white
        padding-top: 2ch

    >.hide-scrollbar
        font-family:"DM Mono", monospace
        overflow: auto
        height: calc(100% - 1.5em - 6vw - 47px)
        position: absolute
        bottom: 0
        left: 0
        right: 0
        margin: 0 auto
        border-top: 1px solid white

        >div >div
            margin-bottom: 2ch

    .bio-block
        padding: 2ch 0
    

    .trayectoria-block
        margin: 1.75ch 0;
        display: grid
        grid-template-columns: 30% 60%
        text-transform: uppercase
        font-weight: 100

/* artworks */
.SectionArtistFull-artworks
    height: 100%

    .tiles-container
        border-radius: 1vw
        height: 100%
        padding-top: 38vw
        overflow: auto
        display: flex
        flex-direction: column
        max-width: unset
        width: 100vw
</style>